// import "./bootstrap.js";

// import Swiper from "swiper";
// import { Navigation, Pagination, EffectCreative } from "swiper/modules";

function init() {
  
}

// Init JS function
document.addEventListener("DOMContentLoaded", (event) => {
  init();
});

// Jquery
jQuery(document).ready(function ($) {
 
});




